export default __webpack_public_path__ + "static/media/music.6a063236.mp3";